import React from 'react';
import '../../css/EmptyState.css';

/**
 * EmptyState — consistent placeholder for empty lists, zero search results,
 * and "nothing here yet" surfaces.
 *
 * Props:
 *   icon        — optional node (e.g. an <svg> or FontAwesomeIcon)
 *   title       — short heading
 *   description — supporting line
 *   action      — optional node (a button / link)
 *   compact     — tighter vertical rhythm for in-panel use
 */
const EmptyState = ({ icon, title, description, action, compact = false, className = '' }) => (
    <div className={`qd-empty ${compact ? 'qd-empty--compact' : ''} ${className}`.trim()}>
        {icon && <div className="qd-empty-icon" aria-hidden="true">{icon}</div>}
        {title && <p className="qd-empty-title">{title}</p>}
        {description && <p className="qd-empty-desc">{description}</p>}
        {action && <div className="qd-empty-action">{action}</div>}
    </div>
);

export default EmptyState;
